import React, { Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';
import { P } from '../../../../AbstractElements';
import { NoDataFound } from '../../../../Constant';
import HeaderCard from '../../../Common/Component/HeaderCard';

const NoDataFoundClass = ({ title }) => {
    return (
        <Fragment>
            <Card className="mb-0">
                <HeaderCard mainClasses="d-flex" title={title} span1={'0 Programmes'} />
                <CardBody>
                    <P>{"No Programmes here yet!"} </P>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default NoDataFoundClass;